function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import ReportTabGeneral from '@/modules/tasks/powerbi/components/report/ReportTabGeneral.vue';
import { ACCES_REQUEST_FILE_FORMAT, ACCESS_TYPE_FLOW } from '@/js/constants';
import tasks from '@/js/tasks';
export default {
  name: 'FormAccessRequestReport',
  components: {
    ReportTabGeneral: ReportTabGeneral
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {}
    },
    accessRequest: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    userBI: {
      type: String,
      required: false,
      default: ''
    },
    emailBI: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      ACCES_REQUEST_FILE_FORMAT: ACCES_REQUEST_FILE_FORMAT,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      files: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      inputUploadFile: null,
      accessRequestClone: Object,
      minDate: new Date().toJSON().slice(0, 10),
      tab: null
    };
  },
  computed: {
    isAccessRequestEmpty: function isAccessRequestEmpty() {
      return !Object.keys(this.accessRequestClone).length;
    }
  },
  created: function created() {
    this.accessRequestClone = Object.assign({}, this.accessRequest);
    if (this.accessRequest && this.accessRequest.endDate && this.accessRequest.endDate.length > 10) {
      var endDate = new Date(this.accessRequest.endDate).toLocaleString().substr(0, 10).split('/').reverse().join('-');
      this.$set(this.accessRequest, 'endDate', endDate);
    }
  },
  methods: {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      if (this.isAccessRequestEmpty) {
        this.sendAccessRequest();
      } else {
        this.responseAccessRequest();
      }
    },
    sendAccessRequest: function sendAccessRequest() {
      var _this = this;
      this.$set(this.item, 'type_flow', ACCESS_TYPE_FLOW.ACCESS);
      this.$set(this.item, 'document_id', this.item.report_id);
      var report = {
        domain: window.userInfo.domain,
        comentary: this.accessRequest.commentary,
        report: this.item,
        endDate: this.accessRequest.endDate,
        benefited: this.emailBI,
        user_bi: this.userBI,
        files_attach: this.files
      };
      BiReportService.reportInitWorkFlow(report).then(function (res) {
        if (res && res.code === 200) {
          if (res.success) {
            tasks.toast.success("Successful request!");
            //this.$toast.success('Successful request')
            _this.onCancel();
          } else {
            tasks.toast.error(res.message);
            //this.$toast.warning(res.message)
            _this.onCancel();
          }
        }
      });
    },
    onReject: function onReject() {
      this.accessRequest.status = "REJECTED";
      this.responseAccessRequest();
    },
    onAccept: function onAccept() {
      this.accessRequest.status = "APPROVED";
      this.responseAccessRequest();
    },
    onAcceptAdd: function onAcceptAdd() {
      this.accessRequest.status = "APPROVED";
      var data = _objectSpread(_objectSpread({}, this.item), {}, {
        response_text: this.accessRequest.response,
        domain: window.userInfo.domain,
        status: this.accessRequest.status,
        type_flow: ACCESS_TYPE_FLOW.ACCESS
      }, this.accessRequest);
      this.$emit('submit', data);
    },
    responseAccessRequest: function responseAccessRequest() {
      var _this2 = this;
      var data = _objectSpread(_objectSpread({}, this.item), {}, {
        response_text: this.accessRequest.response,
        domain: window.userInfo.domain,
        status: this.accessRequest.status,
        type_flow: ACCESS_TYPE_FLOW.ACCESS
      }, this.accessRequest);
      BiReportService.reportSendAssignment(data).then(function (response) {
        if (response.code === 200 && response.success) {
          _this2.onCancel(true);
        }
      }).then(function () {
        console.log(_this2.accessRequest);
        if (_this2.accessRequest.status === 'APPROVED') {
          BiReportService.reportSetPermission(_this2.accessRequest);
          tasks.toast.success("Successful request!");
          //this.$toast.success('Successful request!')
        }
      });
    },
    onCancel: function onCancel() {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$emit('onCloseModal', reload);
    },
    onFileChange: function onFileChange(event) {
      var file = event.target.files[0];
      var fileReader = new FileReader();
      var self = this;
      if (!file || file === undefined) {
        return;
      }
      self.isLoading = true;
      fileReader.onload = function (e) {
        var data = {
          content: e.target.result,
          filename: file.name
        };
        self.dismissCountDown = 0;
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || ''
            };
            self.files.push(_file);
          } else {
            self.dismissCountDown = self.dismissSecs;
            tasks.toast.error(res['message']);
            //alert(res['message'])
          }
          self.isLoading = false;
          self.inputUploadFile = null;
        }).catch(function () {
          self.isLoading = false;
          self.dismissCountDown = self.dismissSecs;
          self.inputUploadFile = null;
        });
      };
      fileReader.readAsDataURL(file);
    },
    deleteFile: function deleteFile(record) {
      var _this3 = this;
      this.isLoading = true;
      if (record.fileId) {
        FilesService.deleteFile(record).then(function (res) {
          var files = _this3.files;
          _this3.files = files.filter(function (file) {
            return file.fileId !== record.fileId;
          });
          _this3.isLoading = false;
        });
      }
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};